<template>
  <ValidationObserver ref="observer">
    <form ref="upload_invoice_form" @submit.prevent="handleSubmit(updateSpj)">

      <md-card>
        <md-card-content>
          <div class="md-layout">
            <!-- <label class="md-layout-item md-size-15 md-form-label">
              <span style="color:green">Attach Invoice</span>
            </label> -->
            <div class="md-layout-item">
              <span v-if="procurement_order.procurement_order_attach_invoice_url" style="color:green"
                >Current Document:
              </span>
              <a v-if="procurement_order.procurement_order_attach_invoice_url" :href="procurement_order.procurement_order_attach_invoice_url" target="_blank">
                    attach_invoice
                    </a>
              <!-- <a
                :href="
                  url_storage +
                    'po_attachment/' +
                    procurement_order.procurement_order_attach_folder +
                    '/' +
                    current_file_attach_invoice
                "
                target="_blank"
              >
                {{ current_file_attach_invoice }}
              </a> -->
              <validation-provider  rules="invoice" v-slot="{ errors }">

                <md-field class="md-invalid">
                  <label for="">Attach Invoice</label>
                  <md-file
                    ref="attach_invoice"
                    @change="on_change_attach_invoice"
                    v-model="procurement_order.procurement_order_attach_invoice"
                    accept="image/jpeg,image/png,application/pdf,application/zip"
                  />
                  <validation-error
                    :errors="apiValidationErrors.procurement_order_attach_invoice"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
            </div>
          </div>
        </md-card-content> 
        

        <md-card-actions>
          <md-button class="md-info md-dense" @click="editConfirmation">
            Update
          </md-button>
        </md-card-actions>

        <div class="border p-2 mt-3">
                <template v-if="file_attach_invoice">
                  <img
                    v-if="
                      file_attach_invoice.type === 'image/jpeg' ||
                        file_attach_invoice.type === 'image/png'
                    "
                    :src="file_attach_invoice.base64"
                    class="img-fluid"
                  />
                  <!-- <p class="mb-0">file name: {{ file_attach_invoice.name }}</p> -->
                  <p class="mb-0">
                    size: {{ file_attach_invoice.size /1048576 }}MB
                  </p>
                </template>
              </div>
      </md-card>

    </form>
  </ValidationObserver>
</template>

<script>
import {ValidationError} from "@/components";
  import formMixin from "@/mixins/form-mixin";
  import { extend , ValidationObserver } from 'vee-validate';
  import { required } from 'vee-validate/dist/rules';
  import Vue from 'vue'
  import VueSweetalert2 from 'vue-sweetalert2';
  import Swal from 'sweetalert2';

  Vue.use(VueSweetalert2);

extend('invoice', {
  ...required,
  message: 'invoice Field is required'
});

  Vue.use(VueSweetalert2);
  export default {
    

    props:{
      data_id:null
    },
    

    components: {ValidationError, ValidationObserver},

    mixins: [formMixin],

    // props:{
    //   data_id:null
    // },
    
   data: () => ({
     procurement_order : [],
     file_attach_invoice : null
    }),

    created() {
      this.getPOData();
    },


     methods: {
       // ambil data yang dibutuhkan
    async getPOData() { 
        await this.$store.dispatch("workshop_procurement_order/get", this.data_id.id)
        this.procurement_order = await this.$store.getters["workshop_procurement_order/procurement_order"]
        
      },

      on_change_attach_invoice: function(event) {
        var input = event.target;
       if(!input.files[0] || (input.files[0].size / 1048576).toFixed(2) > 3){
          if(input.files[0]){
          this.sizeTobig(input.files[0].size) 
          }
          this.resetFile('attach_invoice')
          this.procurement_order.procurement_order_attach_invoice = null
          this.file_attach_invoice = null
          return
        }
        if (input.files) {
          this.readFile('attach_invoice',input)
        }
      },


      sizeTobig(size){
      Swal.fire({
          icon: 'error',
          title: 'File is to big ('+(size / 1048576).toFixed(2)+'MB)',
          text: 'Maximum attachment file size 3MB',
        })
    },


      //fungsi untuk membaca file
      readFile(type,input){
        var reader = new FileReader();
        //read file
          reader.onload = (e) => {
            //buat var dan isi nilainya
            const fileData = {
                  name: input.files[0].name,
                  size: input.files[0].size,
                  lastModified: input.files[0].lastModified,
                  lastModifiedDate: input.files[0].lastModifiedDate,
                  type: input.files[0].type,
                  base64: e.target.result
              }
              //isi nilai var sesuai type
              if(type == "attach_quotation"){
                this.file_attach_quotation = fileData
              }
              if(type == "attach_po"){
                this.file_attach_po = fileData
              }
              if(type == "attach_invoice"){
                this.file_attach_invoice = fileData
              }

            }
            reader.readAsDataURL(input.files[0]);
      },

      resetFile(ref) {
        this.$refs[ref].clearField()
      },

      async editConfirmation(id) {
        const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        return
      }
      Swal.fire({
        title: 'Are you sure?',
        text: 'The data will be edited!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Edit it!',
        cancelButtonText: 'No, cancel!',
        buttonsStyling: true
        }).then((result) => {
          if (result.value){
            this.uploadInvoice()
          }
        });
    },


    // fungsi edit
      async uploadInvoice() {

        // if(this.$route.params.id == null || !this.$route.params.id) {
        //   await this.$store.dispatch("alerts/error", "error")
        //   return
        // }

        const data = {
          type: "workshop_procurement_orders",
          id : this.procurement_order.id,
          procurement_order_attach_invoice: this.file_attach_invoice,

        }

        try {
          //kirim data ke server
          await this.$store.dispatch("workshop_procurement_order/input_invoice", data)
          //panggil alert notifikasi sukses
          await this.$store.dispatch("alerts/success", "Attachment Invoice successfully saved.")
          //kembali ke list
          this.$parent.$parent.modalCloseUploadInvoice();
        } catch (e) {
          //panggil notifikasi error
          
          console.log(e)
          // await this.$store.dispatch("alerts/error", "Oops, something went wrong!")
          // this.setApiValidation(e.response.data.errors)
        }

      }



    // //fungsi yang ada di parent di panggil saat memilih row di table
    // onSelect (item) {
    //   this.$parent.$parent.$parent.$parent.modalCloseListDriver(item,this.item)
    //   },

      

     },

     
     
  }
</script>
<style lang="scss" scoped>
.photo_list{
    max-width: 50%;
    height: auto;
    display: block;
    /* margin-left: auto;
    margin-right: auto; */
}

.v-application--wrap {
  min-height: unset;
}
.v-list-item__title {
    font-size: 0.8rem;
}
.v-menu__content{
    z-index: 10 !important;
}
table > tbody > tr > td.fixed:nth-child(1), 
  table > thead > tr > th.fixed:nth-child(1) {
    position: sticky !important; 
    position: -webkit-sticky !important; 
    left: 0; 
    z-index: 9998;
    background: white;
  }
  table > thead > tr > th.fixed:nth-child(1) {
    z-index: 9999;
  }
</style>